// Tsela Obstacle Safeguarding – Design Tokens
// All theme-sensitive values resolve at runtime via CSS custom properties
// set by ThemeContext (light / dark).  Brand blues are fixed across modes.

export const T = {
  // ── Page backgrounds ──────────────────────────────────────────────────────
  bg0: 'var(--t-bg0)',        // page base (solid)
  bg0g: 'var(--t-bg0g)',       // gradient endpoint
  bg1: 'var(--t-bg1)',        // sidebar / topbar
  bg2: 'var(--t-bg2)',        // card surface (glass)
  bgGlass: 'var(--t-bgGlass)',
  bgGlassLt: 'var(--t-bgGlassLt)',
  surfaceSolid: 'var(--t-surfaceSolid)', // opaque card / glass-tag bg

  // ── Tsela brand blues – same in both modes ────────────────────────────────
  blue: '#3A8AC4',
  blueLt: '#5BA8D9',
  blueDk: '#1E5F9A',
  navy: '#1A3A5C',
  navyLt: '#244E7A',

  // ── Borders ───────────────────────────────────────────────────────────────
  border: 'var(--t-border)',
  borderHi: 'var(--t-borderHi)',

  // ── Text ──────────────────────────────────────────────────────────────────
  white: 'var(--t-white)',     // primary text
  textLt: 'var(--t-textLt)',   // secondary text
  muted: 'var(--t-muted)',    // muted / caption

  // ── Accent ────────────────────────────────────────────────────────────────
  accent: 'var(--t-accent)',      // primary interactive blue
  accentSoft: 'var(--t-accentSoft)', // soft badge background
  badgeBg: 'var(--t-badgeBg)',     // neutral badge background

  // ── Shadows ───────────────────────────────────────────────────────────────
  cardShadow: 'var(--t-cardShadow)',

  // ── Status – fixed, readable on both backgrounds ──────────────────────────
  safe: '#2EC98B',
  warn: '#F5A623',
  danger: '#E84040',
  critical: '#FF1744',
  info: '#5BA8D9',
};

export const BORDER_RADIUS = '8px';

export const CARD_STYLE = {
  background: T.bg2,
  backdropFilter: 'blur(10px)',
  WebkitBackdropFilter: 'blur(10px)',
  border: `1px solid ${T.border}`,
  borderRadius: '28px',
  padding: '1.8rem 1.5rem',
  marginBottom: '12px',
  boxShadow: T.cardShadow,
};

export const statusColor = (status) => {
  const map = {
    penetrated: T.danger,
    critical: T.critical,
    clear: T.safe,
    outside: T.muted,
    info: T.info,
    error: T.warn,
  };
  return map[status] || T.muted;
};
